var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlower = function SvgFlower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.237 10A19.264 19.264 0 0 1 43 23.785C43 34.397 34.493 43 24 43S5 34.397 5 23.785A19.264 19.264 0 0 1 10.763 10M28 9c-.389-1.6-2.722-3.6-3.5-4-.778.4-3.111 2.4-3.5 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.52 16.833C21 13.5 17 11.5 15 11v5.5c0 .464 0 .696.009.893a9 9 0 0 0 8.598 8.598c.197.009.429.009.893.009h2a7.5 7.5 0 0 0 7.5-7.5V11c-3 .333-8.5 4-11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 13.5c-3-5-7-6.5-7-6.5v5M26 10c2.8-3.068 5-2.985 5-2.985V12M22 26v16m4-12.973V42M20 35h-3a5 5 0 0 1-5-5v-2h4a6 6 0 0 1 6 6v.125M29 36h2a5 5 0 0 0 5-5v-1h-4a6 6 0 0 0-6 6v1"
  }))));
};
export default SvgFlower;